import * as yup from 'yup';

export const formSchema = yup.object().shape({
  group_name: yup.string().required('Este campo é obrigatório.'),
});
